
import React from "react";
import { useClose } from "@/contexts/CloseContext";
import { User } from "lucide-react";

export const CloseConnectionStatus = () => {
  const { isConnected, userEmail, userName } = useClose();
  
  const displayName = userName || userEmail || "Anonymer Benutzer";

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2">
        <div className={`w-3 h-3 rounded-full ${isConnected ? 'bg-green-500' : 'bg-red-500'}`}></div>
        <div>
          <span className={`text-sm ${isConnected ? 'text-green-500' : 'text-red-500'}`}>
            {isConnected ? 'Direkt verbunden mit Close API' : 'Nicht verbunden mit Close API'}
          </span>
          {isConnected && userEmail && (
            <div className="flex items-center gap-1 text-xs text-gray-400">
              <User size={12} />
              <span title={userEmail}>{displayName}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
